import { type FC } from 'react'

import { type SingleSelectedValueFilter } from 'components/brokers/types'
import { isValidFipsCode, isValidHiosId, isValidMedicalPlanId, isValidMemberId, isValidZipCode } from 'utils'

import ValidatedTextInputFilter from './ValidatedTextInputFilter'

/**
 * Factory function to create validated filter components.
 * Reduces duplication across similar validated text input filters.
 *
 * @param validator - Function to validate the input value
 * @param placeholder - Placeholder text to display in the input
 * @returns A filter component that validates input
 */
export const createValidatedFilter = (
  validator: (value: string) => boolean,
  placeholder: string
): FC<SingleSelectedValueFilter> => {
  const ValidatedFilter: FC<SingleSelectedValueFilter> = (props) => {
    return (
      <ValidatedTextInputFilter
        {...props}
        validator={validator}
        placeholder={placeholder}
      />
    )
  }

  return ValidatedFilter
}

// Pre-configured validated filter components
export const ZipCodeFilter = createValidatedFilter(isValidZipCode, 'e.g., 94105')
export const FipsCountyCodeFilter = createValidatedFilter(isValidFipsCode, 'e.g., 06075')
export const MemberIdFilter = createValidatedFilter(isValidMemberId, 'mbr_...')
export const MedPlanIdFilter = createValidatedFilter(isValidMedicalPlanId, 'e.g., mdpln_...')
export const HiosIdFilter = createValidatedFilter(isValidHiosId, 'e.g., 70285CA1250001')
